import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../i18n';
import {mapDispatchToProps} from "../mapDispatchToProps"
import {apiUrl} from './../../actions/config';
import queryString from "query-string";

class OauthAuthorize extends React.Component {
  constructor(props) {
    super(props);
    this.agree = this.agree.bind(this)
  }
  agree() {
    let url = '/'
    const oauth_authorize = JSON.parse(localStorage.getItem('oauth_authorize'))
    const mf_authorization = JSON.parse(localStorage.getItem('mf_authorization'))
    const token = mf_authorization && mf_authorization.access_token && mf_authorization.access_token.token
    if(oauth_authorize && oauth_authorize.client_id && oauth_authorize.redirect_uri) {
      url = `${apiUrl}oauth/authorize?${queryString.stringify(oauth_authorize)}&user_token=${token}`
    }

    //Tracking to app_authorized_logs
    this.props.userActions.addAppAuthorizedLog({client_id: oauth_authorize.client_id})

    localStorage.removeItem('oauth_authorize')
    window.location.href = url
  }

  cancel() {
    let url = '/'
    const oauth_authorize = JSON.parse(localStorage.getItem('oauth_authorize'))
    if(oauth_authorize && oauth_authorize.redirect_uri) {
      url = oauth_authorize.redirect_uri
    }

    localStorage.removeItem('oauth_authorize')
    window.location.href = url
  }

  render() {
    const oauth_authorize = JSON.parse(localStorage.getItem('oauth_authorize'))
    let isMissingParams = false
    if(!oauth_authorize || !oauth_authorize.client_id || !oauth_authorize.redirect_uri) {
      isMissingParams = true
    }

    return (
      <div className="login-container">
        <div className="text-center authorize-message">
          <p className="line1">{i18n.t("oauth_authorize.authorize.title")}</p>
          {isMissingParams && <p className="text-center line1 text-danger">{i18n.t("oauth_authorize.authorize.error")}</p>}
          {!isMissingParams && <div>
            <p className="message">外部サービスとの連携により外部サービスの提供会社に提供される情報</p>
            <p className="message">は、契約者が、本サービスにおいて当社に提供し、又は契約者の提供し</p>
            <p className="message"> た情報に基づき当社がアクセスできる契約者の口座情報を含む一切</p>
            <p className="message">の情報となります。（ただし、契約者が登録したアクセスに必要な認証</p>
            <p className="message">情報（ユーザーID及びパスワード等）自体は含みません。）</p>
            <p className="text-center line2">{i18n.t("oauth_authorize.authorize.desc")}</p>
            <button className="btn mfc-btn-blue medium" type="button" onClick={this.agree}>{i18n.t("oauth_authorize.authorize.yes")}</button>
            <button className="btn mfc-btn-gray medium" style={{marginLeft: '20px'}} onClick={this.cancel}>{i18n.t("oauth_authorize.authorize.no")}</button>
          </div>}
        </div>
      </div>
    )
  }
}

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(OauthAuthorize)
